import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Button from '../Button'
import { SECONDARY_BUTTON } from '../../../constants/buttonThemes'
import Text from '../Text'
import { VERMILION, TEXT_BIG, METAL } from '../../../constants'

const Grid = styled.div`
  display: grid;
  grid-gap: 10px;
`

//the grid of rules checkboxes and labels
const RuleCheckboxContainer = styled.div`
  display: grid;
  column-gap: 10px;
  row-gap: 10px;
  padding-left: 10px;
  padding-right: 10px;
  align-items: center;
  grid-template-columns: 33% 33% 33%;
`

//each individual checkbox and label contained within this flex
const RuleCheckboxItem = styled.label`
  display: flex;
  align-items: stretch;
`

const RuleTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 20px;
`

const CheckboxSpan = styled.span`
  max-width: 40px;
  display: flex;
`

const CheckboxLabelSpan = styled.span`
  display: -webkit-box;
  max-height: 50px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

const RuleSelectionSection = ({
  ruleGroupId,
  ruleGroupName,
  rulesList,
  selectedRulesList,
  setSelectedRulesList,
  resetSelectedRuleset,
  allowSelectAll = true,
}) => {
  const { t } = useTranslation()

  function RenderSelectAllButton() {
    if (!allowSelectAll) {
      return <></>
    }
    return (
      <Button
        data-id={'select-all-' + ruleGroupName}
        theme={SECONDARY_BUTTON}
        onClick={() => {
          selectAllRulesFromSection()
        }}
      >
        {t('feed_audit_select_all')}
      </Button>
    )
  }

  function selectAllRulesFromSection() {
    resetSelectedRuleset()
    rulesList.forEach(rule => {
      //the rule is not already selected, add it
      if (!selectedRulesList.includes(rule.id)) {
        setSelectedRulesList(selectedRulesList => [
          ...selectedRulesList,
          rule.id,
        ])
      }
    })
  }

  function RenderRules() {
    return rulesList.map(rule => (
      <div key={ruleGroupId + '-' + rule.id + '-holder'}>
        <RuleCheckboxItem>
          <CheckboxSpan>
            <input
              type="checkbox"
              color={VERMILION}
              checked={selectedRulesList.includes(rule.id)}
              style={{ marginRight: 10 }}
              onChange={event => {
                resetSelectedRuleset()
                selectedRulesList.includes(rule.id)
                  ? //if the rule is in the list, filter it out
                    setSelectedRulesList(
                      selectedRulesList.filter(r => r !== rule.id)
                    )
                  : //if the rule is not in the list, add it to the end of the list
                    setSelectedRulesList(selectedRulesList => [
                      ...selectedRulesList,
                      rule.id,
                    ])
              }}
              key={ruleGroupId + '-' + rule.id}
            />
          </CheckboxSpan>
          <CheckboxLabelSpan>{rule.name}</CheckboxLabelSpan>
        </RuleCheckboxItem>
      </div>
    ))
  }

  // Protect againt groups with no rules
  if (!rulesList || rulesList.length === 0) {
    return <></>
  }

  return (
    <Grid>
      <RuleTitleContainer>
        <Text size={TEXT_BIG} color={METAL}>
          {ruleGroupName}
        </Text>
        <RenderSelectAllButton />
      </RuleTitleContainer>
      <RuleCheckboxContainer>
        <RenderRules />
      </RuleCheckboxContainer>
    </Grid>
  )
}

export default RuleSelectionSection
